import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { ShopProvider } from "@/context/ShopContext";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Drops from "@/pages/Drops";
import Collections from "@/pages/Collections";
import CollectionDetail from "@/pages/CollectionDetail";
import ProductDetail from "@/pages/ProductDetail";
import CartPage from "@/pages/CartPage";
import Account from "@/pages/Account";
import TrackOrder from "@/pages/TrackOrder";
import About from "@/pages/About";
import RunClub from "@/pages/RunClub";
import Contact from "@/pages/Contact";
import FAQ from "@/pages/FAQ";
import { ShippingReturns, Privacy, Terms } from "@/pages/StaticPages";
import NotFound from "@/pages/NotFound";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);
  return null;
};

function App() {
  return (
    <div className="App">
      <div className="noise-overlay" />
      <ThemeProvider>
        <ShopProvider>
          <CartProvider>
            <BrowserRouter>
              <SmoothScroll />
              <ScrollToTop />
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/shop" element={<Shop />} />
                  <Route path="/drops" element={<Drops />} />
                  <Route path="/collections" element={<Collections />} />
                  <Route path="/collections/:handle" element={<CollectionDetail />} />
                  <Route path="/product/:handle" element={<ProductDetail />} />
                  <Route path="/cart" element={<CartPage />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/track-order" element={<TrackOrder />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/run-club" element={<RunClub />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/faq" element={<FAQ />} />
                  <Route path="/shipping-returns" element={<ShippingReturns />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </main>
              <Footer />
              <CartDrawer />
              <Toaster
                position="bottom-center"
                theme="dark"
                toastOptions={{
                  style: {
                    background: "#111",
                    border: "1px solid rgba(255,255,255,0.12)",
                    borderRadius: 0,
                    fontFamily: "'JetBrains Mono', monospace",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    letterSpacing: "0.15em",
                  },
                }}
              />
            </BrowserRouter>
          </CartProvider>
        </ShopProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
